import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { trim } from 'lodash';
import { Helmet } from 'react-helmet';
import queryString, { ParsedQuery } from 'query-string';

// @ts-ignore
import { getIsLoadingResetPassword } from 'store/services/session/selectors';
// @ts-ignore
import { resetPassword } from 'store/services/session/actions';
import { SessionRootState } from 'store/services/session/types';
import Layout from 'components/AuthLayout';
import TextFieldReduxWrapper from 'components/TextFieldReduxWrapper';
// @ts-ignore
import MESSAGES from 'constants/messages';
import FORM_NAMES from 'constants/formNames';

import { SH1, SButton } from './styled';

import validate from './utils';

type FormParams = {
  password: string;
  confirm_password: string;
};

interface StateProps {
  isLoading: boolean;
}

interface DispatchProps {
  resetPassword: (params: FormParams | ParsedQuery<string>) => Promise<boolean>;
}

interface OwnProps {
  location: { search: string };
}

type CustomProps = OwnProps & StateProps & DispatchProps;

type Props = CustomProps & InjectedFormProps<FormParams, CustomProps>;

const ResetPassword = ({
  isLoading,
  invalid,
  handleSubmit,
  location,
  resetPassword,
}: Props) => {
  const { email, token }: ParsedQuery<string> = queryString.parse(
    location.search,
  );

  const onSubmit = (data: FormParams) =>
    resetPassword({
      ...data,
      token,
      email,
    });

  return (
    <Layout onSubmit={handleSubmit(onSubmit)}>
      <Helmet>
        <title>Reset password</title>
      </Helmet>

      <SH1 data-test="title">Reset password</SH1>

      <Field
        component={TextFieldReduxWrapper}
        data-test="email"
        label="New password"
        name="password"
        normalize={trim}
        placeholder={MESSAGES.RESET_PASSWORD.PASSWORD.PLACEHOLDER}
        type="password"
      />

      <Field
        component={TextFieldReduxWrapper}
        data-test="password"
        label="Confirm password"
        name="confirm_password"
        normalize={trim}
        placeholder={MESSAGES.RESET_PASSWORD.CONFIRM_PASSWORD.PLACEHOLDER}
        type="password"
      />

      <SButton
        block
        color="primary"
        data-test="submit"
        disabled={invalid || !email || !token || isLoading}
        loading={isLoading}
        type="submit"
        variant="contained"
      >
        Reset password
      </SButton>
    </Layout>
  );
};

const mapStateToProps = (
  state: Pick<SessionRootState, 'resetPassword'>,
): StateProps => ({
  isLoading: getIsLoadingResetPassword(state),
});

export default compose(
  connect(
    mapStateToProps,
    { resetPassword },
  ),
  reduxForm({
    form: FORM_NAMES.PASSWORD.RESET,
    validate,
    touchOnChange: true,
    initialValues: {
      password: '',
      confirm_password: '',
    },
  }),
)(ResetPassword) as React.FC<
  StateProps & DispatchProps & OwnProps & Partial<InjectedFormProps>
>;
